var validationUtils = require('../../entities/validation');
var EntitiesBase = require('../../entities/base_rest');
var ProductVendorModel = EntitiesBase.ModelBase.extend({
    constructor: function(attrs, options) {
        EntitiesBase.ModelBase.prototype.constructor.call(this, attrs, options);
    },
    urlRoot: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/product-vendors';
    },
    validation: {
        name: {
            required: true
        },
        code: {
            required: true
        },
        lat: {
            required: false,
            latitude: true
        },
        lng: {
            required: false,
            longitude: true
        }
    }
});
_.extend(ProductVendorModel.prototype, Backbone.Validation.mixin);

var PageableProductVendorsCollection = EntitiesBase.PageableCollectionBase.extend({
    constructor: function(models, options) {
        EntitiesBase.PageableCollectionBase.prototype.constructor.call(this, models, options);
    },
    url: function () {
        return farmacy.settings.restAPI.root + 'wp/v3/product-vendors';
    },
    state: _.extend({},
        EntitiesBase.PageableCollectionBase.prototype.state, {
            sortKey: 'code',
            order: EntitiesBase.SORT_DIRECTIONS.ASC,
            filterHideOnMenuFilter: true
        }
    ),
    model: ProductVendorModel,
});

module.exports = {
    ProductVendorModel: ProductVendorModel,
    PageableProductVendorsCollection: PageableProductVendorsCollection
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/admin-app/entities/product-vendor.js
 ** module id = 42
 ** module chunks = 1 2 3 4 5 6 7 8 10 11 13 14 17 18 20 21 24 29 30 31 33 35 37 43 44 47 52 63 64 73 74 76 84 91 92 94 95 96 97 102 113 131 135 147 157 208
 **/